
/* MEDIOS DE IMPUGNACION */
export const dataEstrados = [

  {
    id: 1,
    numCedula: 1,
    folio: "03850-2026",
    pdfMedio: "03850-2026-1.pdf",
    pdfCedula: "03850-2026-2.pdf",
  },
  {
    id: 2,
    numCedula: 2,
    folio: "03867-2026",
    pdfMedio: "03867-2026-1.pdf",
    pdfCedula: "03867-2026-2.pdf",
  },

  {
    id: 3,
    numCedula: 3,
    folio: "03897-2026",
    pdfMedio: "03897-2026-1.pdf",
    pdfCedula: "03897-2026-2.pdf",
  },

  {
    id: 4,
    numCedula: 4,
    folio: "03898-2026",
    pdfMedio: "03898-2026-1.pdf",
    pdfCedula: "03898-2026-2.pdf",
  },

  {
    id: 5,
    numCedula: 5,
    folio: "03898-2026",
    pdfMedio: "03900-2026-1.pdf",
    pdfCedula: "03900-2026-2.pdf",
  },


  {
    id: 6,
    numCedula: 6,
    folio: "03901-2026",
    pdfMedio: "03901-2026-1.pdf",
    pdfCedula: "03901-2026-2.pdf",
  },



  {
    id: 7,
    numCedula: 7,
    folio: "03918-2026",
    pdfMedio: "03918-2026-1.pdf",
    pdfCedula: "03918-2026-2.pdf",
  },


  {
    id: 8,
    numCedula: 8,
    folio: "03922-2026",
    pdfMedio: "03922-2026-1.pdf",
    pdfCedula: "03922-2026-2.pdf",
  },

  {
    id: 9,
    numCedula: 9,
    folio: "03931-2026",
    pdfMedio: "03931-2026-1.pdf",
    pdfCedula: "03931-2026-2.pdf",
  },
  {
    id: 10,
    numCedula: 10,
    folio: "03932-2026",
    pdfMedio: "03932-2026-1.pdf",
    pdfCedula: "03932-2026-2.pdf",
  },

  {
    id: 11,
    numCedula: 11,
    folio: "03940-2026",
    pdfMedio: "03940-2026-1.pdf",
    pdfCedula: "03940-2026-2.pdf",
  },

  {
    id: 12,
    numCedula: 12,
    folio: "03942-2026",
    pdfMedio: "03942-2026-1.pdf",
    pdfCedula: "03942-2026-2.pdf",
  },
  {
    id: 13,
    numCedula: 13,
    folio: "03945-2026",
    pdfMedio: "03945-2026-1.pdf",
    pdfCedula: "03945-2026-2.pdf",
  },
  {
    id: 14,
    numCedula: 14,
    folio: "03953-2026",
    pdfMedio: "03953-2026-1.pdf",
    pdfCedula: "03953-2026-2.pdf",
  },
];


/* AMONESTACIONES PUBLICAS */


export const dataAmonestaciones = [
  /* SUBIDA: 01/07/26 BAJADA: 31/07/26 */
  {
    id: 1,
    numCedula: 32,
    pdfUrl: "32.pdf",
  },
  {
    id: 1,
    numCedula: 49,
    pdfUrl: "49.pdf"
  },
  {
    id: 1,
    numCedula: 50,
    pdfUrl: "50.pdf",
  },
];

/* ACUERDOS JUNTA GENERAL EJECUTIVA */
export const dataAcuerdosjge = [
  {
    id: 1,
    numCedula: 1,
    pdfUrl: "1jge.pdf",
    nameDoc: " POR EL QUE SE APRUEBA LA SUSPENSIÓN DE PLAZOS Y TÉRMINOS DERIVADO DEL PRIMER PERIODO VACACIONAL CORRESPONDIENTE AL AÑO DOS MIL VEINTICINCO DEL PERSONAL DE ESTE INSTITUTO.",
  },
  {
    id: 2,
    numCedula: 2,
    pdfUrl: "2jge.pdf",
    nameDoc: "POR EL QUE SE APRUEBA LA SUSPENSIÓN DE PLAZOS Y TÉRMINOS DERIVADO DEL PRIMER PERIODO VACACIONAL CORRESPONDIENTE AL AÑO DOS MIL VEINTICINCO DEL PERSONAL DE ESTE INSTITUTO.",
  },
  {
    id: 3,
    numCedula: 3,
    pdfUrl: "3jge.pdf",
    nameDoc: "POR EL QUE SE APRUEBA LA SUSPENSIÓN DE PLAZOS Y TÉRMINOS DERIVADO DEL PRIMER PERIODO VACACIONAL CORRESPONDIENTE AL AÑO DOS MIL VEINTISEIS DEL PERSONAL DE ESTE INSTITUTO.",
  },
  {
    id: 4,
    numCedula: 4,
    pdfUrl: "4jge.pdf",
    nameDoc: "COMUNICADO",
  },
];


export const dataDelegacionOE = [
  {
    id: 1,
    folio: "01-2025",
    pdfAcuerdo: "01-2025.pdf",
  },
  {
    id: 1,
    folio: "02-2025",
    pdfAcuerdo: "02-2025.pdf",
  },
  {
    id: 1,
    folio: "03-2025",
    pdfAcuerdo: "03-2025.pdf",
  },
  {
    id: 1,
    folio: "04-2025",
    pdfAcuerdo: "04-2025.pdf",
  },
  {
    id: 1,
    folio: "05-2025",
    pdfAcuerdo: "05-2025.pdf",
  },
  {
    id: 1,
    folio: "01-2026",
    pdfAcuerdo: "01-2026.pdf",
  },
  {
    id: 1,
    folio: "02-2026",
    pdfAcuerdo: "02-2026.pdf",
  },
  {
    id: 1,
    folio: "03-2026",
    pdfAcuerdo: "03-2026.pdf",
  },
  {
    id: 1,
    folio: "04-2026",
    pdfAcuerdo: "04-2026.pdf",
  },
  {
    id: 1,
    folio: "05-2026",
    pdfAcuerdo: "05-2026.pdf",
  },
];


/* MOSTRAR DEÑ 07 DE AGOSTO AL 21 DE AGOSTO */
export const dataListadoDA = [
  {
    id: 1,
    folio: "Listado de Personas con Doble Afiliación a Partidos Políticos",
    pdfAcuerdo: "ListadoDA.pdf",
    pdfAnexo: "ListadoDA-Anexo.pdf",
  },
];


export const dataConvocatorias = [
  /* {
   id: 1,
  nameFile: "Convocatoria-Licitacion-Publica-Nacional-ITE-01-2024",
   linkFile:
    "https://itetlax.org.mx/assets/pdf/convocatorias/Convocatoria-Licitacion-Publica-Nacional-ITE-01-2024.pdf",
  }, */
];

export const dataConvocatoriasApartado = [
  {
    id: 1,
    nameFile: "Convocatoria Licitacion ITE-LP-06-2024",
    linkFile:
      "https://itetlax.org.mx/assets/pdf/convocatorias/Convocatoria-ITE-LP-06-2024.pdf",
  },
];

export const dataInformes = [
  {
    mes: "Marzo",
    titulo:
      "INFORME DE LA SECRETARÍA EJECUTIVA RESPECTO DE LA RECEPCIÓN DE LOS LISTADOS Y EXPEDIENTES DIGITALES DE LAS PERSONAS CANDIDATAS DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    linkFile: "https://itetlax.org.mx/assets/pdf/informes/1.pdf",
  },

  {
    mes: "Marzo",
    titulo:
      "LISTADO DE MAGISTRADOS Y JUECES QUE VAN DIRECTO A LA BOLETA Y LAS PERSONAS CANDIDATAS QUE PASARON LA INSACULACIÓN” ENTREGADO POR EL CONGRESO DEL ESTADO DE TLAXCALA AL ITE DÍA 13 DE MARZO DE 2025.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Listado.pdf",
  },
  {
    mes: "Marzo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO REMITIDO POR EL CONGRESO DEL ESTADO DE TLAXCALA EL DÍA 18 DE MARZO DE 2025 AL ITE.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoActualizado.pdf",
  },
  {
    mes: "Marzo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO (21/MARZO/2025) DERIVADO DE SOLICITUD DE ACLARACIÓN REALIZADA AL CONGRESO DEL ESTADO POR EL ITE.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Listado21deMarzo.pdf",
  },
  {
    mes: "Abril",
    titulo:
      "ACTUALIZACIÓN DE LISTADO (10/ABRIL/2025) DERIVADO DE LAS SUSTITUCIONES REALIZADAS POR EL CONGRESO DEL ESTADO DE TLAXCALA.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoCuarto.pdf",
  },
  {
    mes: "Abril",
    titulo:
      "UBICA TU CASILLA",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Casilla.pdf",
  },
  {
    mes: "Abril",
    titulo:
      "ACTUALIZACIÓN DE LISTADO (15/ABRIL/2025) DERIVADO DE DIVERSAS ACTUACIONES",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Listado1504.pdf",
  },
  {
    mes: "Abril",
    titulo:
      " ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (16/ABRIL/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoSeis.pdf",
  },


  {
    mes: "Abril",
    titulo:
      "INFORME CRONOLÓGICO CON CORTE AL 16 DE ABRIL DE 2025, QUE PRESENTA LA SECRETARIA EJECUTIVA  RESPECTO DE LAS ACTIVIDADES RELACIONADAS CON LA ENTREGA DE LOS LISTADOS REMITIDOS POR EL CONGRESO DEL ESTADO DE TLAXCALA.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/INFORME_FINAL_CRONOLOGÍA.pdf",
  },


  {
    mes: "Abril",
    titulo:
      "LISTADO ACTUALIZADO DE CANDIDATURAS A MAGISTRATURAS DEL TRIBUNAL SUPERIOR DE JUSTICIA, MAGISTRATURAS DEL TRIBUNAL DE DISCIPLINA JUDICIAL, MAGISTRATURAS DEL TRIBUNAL DE JUSTICIA ADMINISTRATIVA, MAGISTRATURAS DEL TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE, Y JUEZAS Y JUECES DEL PODER JUDICIAL LOCAL",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoActualizadoOrganizacion.pdf",
  },
  {
    mes: "Mayo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (17/MAYO/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/LISTADOSIETE.pdf",
  },
  {
    mes: "Mayo",
    titulo:
      "UBICACIÓN E INTEGRACIÓN DE MESAS DIRECTIVAS DE CASILLA (ENCARTE).",
    linkFile: "https://itetlax.org.mx/assets/pdf/ListadoCasillasAct.pdf",
  },
  {
    mes: "Mayo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (23/MAYO/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/Listado8.pdf",
  },
  {
    mes: "Mayo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (31/MAYO/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/Listado9.pdf",
  },
];
